import { render, staticRenderFns } from "./ClientChanges.vue?vue&type=template&id=322f62f1&scoped=true&"
import script from "./ClientChanges.vue?vue&type=script&lang=js&"
export * from "./ClientChanges.vue?vue&type=script&lang=js&"
import style0 from "./ClientChanges.vue?vue&type=style&index=0&id=322f62f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322f62f1",
  null
  
)

export default component.exports